<template>
  <div class="table">
    <ul class="head">
      <li class="date">
        <p>日</p>
      </li>
      <li class="weather">
        <p>天気</p>
      </li>
      <li class="high">
        <p>最高</p>
      </li>
      <li class="low">
        <p>最低</p>
      </li>
      <li class="status">
        <p>服装</p>
        <button
          class="info"
          @click="$emit('open-modal')"
        />
      </li>
      <li class="rain">
        <p>降水</p>
      </li>
    </ul>
    <div
      ref="body"
      class="body"
    >
      <ul
        v-for="content in table"
        :key="content.date"
        class="content"
        :class="content.past && 'past'"
      >
        <li
          class="date"
          :class="content.dowEn && content.dowEn"
        >
          <p class="day">
            {{ content.date }}
          </p>
          <p class="dow">
            ({{ content.dowJa }})
          </p>
        </li>
        <li class="weather">
          <figure>
            <img
              :src="'https://gvs.weathernews.jp/onebox/img/wxicon/' + content.wx + '.webp'"
              width="152"
              height="112"
              loading="lazy"
              alt=""
            >
          </figure>
        </li>
        <li class="high">
          <p>{{ content.maxt }}<span>℃</span></p>
        </li>
        <li class="low">
          <p>{{ content.mint }}<span>℃</span></p>
        </li>
        <li class="status">
          <figure
            :data-tooltip="getClothIconTelop(content.daytimeClothRank)"
          >
            <img
              :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/tops_${content.daytimeClothRank == null ? 'null' : content.daytimeClothRank.toString().padStart(2, '0')}.svg`"
              alt=""
              width="41"
              height="36"
              loading="lazy"
            >
          </figure>
        </li>
        <li class="rain">
          <p>{{ content.pop }}<span v-if="content.pop !== '0'">%</span></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
defineProps({
  /**
   * @type {Array<
   * {
   *    past: boolean,
   *    date: string,
   *    dowJp: string,
   *    weather: string,
   *    high: string,
   *    low: string,
   *    rain: string;
   *    daytimeClothRank: number;
   *    nighttimeClothRank: number;
   * }
   * >}
   */
  table: {
    type: Array,
    required: true
  }
})
defineEmits(['open-modal'])

const runtimeConfig = useRuntimeConfig()
</script>

<style lang="scss" scoped>
.table {
  display: flex;
  position: relative;
  width: 100%;
  height: 214px;
  border: solid 1px #dfe4f0;
  border-radius: 8px;
  background-color: #f9f9f9;
  overflow: hidden;
  &::after {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 10px;
    height: 100%;
    background: linear-gradient(to right, rgba(0 0 0 / 0), rgba(0 0 0 / .3));
    content: "";
  }
  .head {
    display: flex;
    position: relative;
    flex-direction: column;
    width: 45px;
    background-color: #eef1f8;
    box-shadow: 3px 0 6px 0 rgba(0 0 0 / .3);
    z-index: 2;
    .date {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      border-bottom: solid 1px #dfe4f0;
    }
    .weather {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      border-bottom: solid 1px #dfe4f0;
    }
    .high,
    .low,
    .rain {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
    }
    .high,
    .low,
    .status {
      border-bottom: solid 1px #dfe4f0;
    }
    p {
      font-size: 14px;
      line-height: 14px;
      text-align: center;
    }
    .status {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      .info {
        position: absolute;
        width: 12px;
        height: 12px;
        min-height: auto;
        top: 1px;
        right: 1px;
        background-image: url('~/assets/images/common/icon_info.svg');
        background-position: center;
        background-size: cover;
      }
    }
  }
  .body {
    position: relative;
    display: flex;
    flex: 1;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 8px;
      background-color: #eef1f8;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: #438fec;
    }
    .content {
      display: flex;
      flex-direction: column;
      flex: 1;
      // 過去情報を入れた関係で本日＆未来（11日）を見えるようにする。651pxで52px固定
      min-width: max(calc(100% / 11), 52px);
      margin: 0;
      gap: 0;
      .date {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        border-bottom: solid 1px #dfe4f0;
        &.sat {
          p {
            color: #0060ff;
            &:is(.past *) {
              color: #609cfe;
            }
          }
        }
        &.sun,
        &.hol {
          p {
            color: #ff3000;
            &:is(.past *) {
              color: #ff7e5f;
            }
          }
        }
        p {
          font-size: 13px;
          font-weight: 600;
          line-height: 15px;
          &:is(.past *) {
            color: #a3a3a3;
          }
        }
      }
      .weather {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        border-bottom: solid 1px #dfe4f0;
        figure {
          width: 40px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            aspect-ratio: 152 / 112;
          }
        }
        &:is(.past *) {
          filter: grayscale(1);
        }
      }
      .high,
      .low,
      .rain {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        p {
          font-size: 15px;
          font-weight: 600;
          line-height: 15px;
          span {
            margin-left: 2px;
            font-size: 10px;
            font-weight: 300;
          }
          &:is(.past *) {
            color: #a3a3a3;
          }
        }
      }
      .high,
      .low,
      .status {
        border-bottom: solid 1px #dfe4f0;
      }
      .high {
        p {
          color: #f64d00;
        }
      }
      .low {
        p {
          color: #0075f3;
        }
      }
      .status {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-block: 4px;
        height: 50px;
        figure {
          position: relative;
          text-align: center;
          height: 36px;
          img {
            width: auto;
            height: 100%;
          }
          &:hover {
            &::after {
              opacity: 1;
            }
          }
          &::after {
            position: absolute;
            bottom: 105%;
            left: 0;
            display: block;
            padding: 7px 8px 5px;
            background: #000;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 300;
            color: #fff;
            white-space: nowrap;
            content: attr(data-tooltip);
            opacity: 0;
            z-index: 10;
            transition: opacity .2s ease-in-out;
            pointer-events: none;
          }
          &:hover::after,
          &:focus::after,
          &:active::after {
            opacity: 1;
          }
        }
      }
      &:nth-last-child(-n + 4) {
        .status {
          figure {
            &::after {
              left: auto;
              right: 0;
            }
          }
        }
      }
    }
  }
  .note {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-width: 48px;
    background-color: #E3E6E9;
    &__title {
      color: #303030;
      text-align: center;
      font-size: 12px;
      font-weight: 600;
      line-height: 1em;
    }
    &__info {
      display: flex;
      flex-direction: column;
      gap: 4px;
      p {
        color: #303030;
        text-align: center;
        font-size: 12px;
        line-height: 1em;
      }
    }
    &__rank {
      display: flex;
      flex-direction: column;
      gap: 1px;
      p {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        background-color: #9FA9B3;
        color: #FFF;
        text-shadow: 0 0.889px 1.778px rgb(0 0 0 / 0.40);
        font-size: 14px;
        font-weight: 700;
      }
    }
    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 2px;
      background: linear-gradient(180deg, rgb(0 0 0 / 0.33) 0%, rgb(0 0 0 / 0.66) 100%);
      color: #fff;
      font-weight: 600;
      font-size: 12px;
      line-height: 1em;
    }
  }
  @media (any-hover: hover) {
    .head {
      .status {
        .info {
          cursor: pointer;
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
      }
    }
    .note {
      &__button {
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
}
</style>
